module.exports = __webpack_public_path__ + "img/small-4.1aeb0123.jpg";